import type { DirectorNotePlacement } from '@/types/domain'

export interface ChatComposerState {
  message: string
  note: string
  placement: DirectorNotePlacement
  expires: boolean
  life: number
}

export function createBlankChatComposerState(): ChatComposerState {
  return { message: '', note: '', placement: 'append', expires: false, life: 3 }
}
